import { useOptimizelyFeature } from '@src/utils/hooks/useOptimizelyFeature'
import * as React from 'react'
import { connect } from 'react-redux'
import { setFeatureFlags } from './state/featureFlags/actions'
import { UPLOAD_WIDGET_DEMO } from './state/optimizely/constants'

interface FeatureFlagsProviderProps {
  setFeatureFlags: (featureFlags: any) => void
}

const FeatureFlagsProvider: React.FunctionComponent<FeatureFlagsProviderProps> = ({
  setFeatureFlags,
  children,
}) => {
  const { isEnabled: demoActive, clientReady } = useOptimizelyFeature(UPLOAD_WIDGET_DEMO)

  React.useEffect(() => {
    if (clientReady) {
      setFeatureFlags({ demoActive, clientReady })
    }
  }, [setFeatureFlags, demoActive, clientReady])

  return <>{children}</>
}

const mapDispatchToProps = {
  setFeatureFlags,
}

export default connect(null, mapDispatchToProps)(FeatureFlagsProvider)



// WEBPACK FOOTER //
// ./src/FeatureFlagsProvider.tsx